import { Notification } from '../../models/notification/notification'

export enum NotificationTypeEnum {
  ADMIN_REMIND_PCR = 'ADMIN_REMIND_PCR',
  ADMIN_CHANGE_PCR = 'ADMIN_CHANGE_PCR',
  ADMIN_CHANGE_CANDIDATE_PRIORITY = 'ADMIN_CHANGE_CANDIDATE_PRIORITY',
  PCR_CLASSIFY_CANDIDATE = 'PCR_CLASSIFY_CANDIDATE',
  RESERVATION_REMINDER = 'RESERVATION_REMINDER',
  MISSING_DPAE_REMINDER = 'MISSING_DPAE_REMINDER',
  STAFF_ATTENDANCE_FINALIZED = 'STAFF_ATTENDANCE_FINALIZED',
  AFFECTED_STAFF_APPLICATION_INCOMPLETE = 'AFFECTED_STAFF_APPLICATION_INCOMPLETE',
  DIFFUSION_NOTIFICATION = 'DIFFUSION_NOTIFICATION',
  ENROLLMENT_CANCELLATION_NOTIFICATION = 'ENROLLMENT_CANCELLATION_NOTIFICATION'
}

export const notificationTypeMapping: Record<NotificationTypeEnum, string> = {
  ADMIN_REMIND_PCR: 'Rappel',
  ADMIN_CHANGE_PCR: 'Changement de PCR',
  ADMIN_CHANGE_CANDIDATE_PRIORITY: 'Changement de priorité',
  PCR_CLASSIFY_CANDIDATE: 'Changement de statut',
  RESERVATION_REMINDER: 'Rappel de réservation',
  MISSING_DPAE_REMINDER: 'DPAE manquante',
  STAFF_ATTENDANCE_FINALIZED: "Liste d'appel finalisée",
  AFFECTED_STAFF_APPLICATION_INCOMPLETE: 'Candidature incomplète',
  DIFFUSION_NOTIFICATION: 'Diffusion',
  ENROLLMENT_CANCELLATION_NOTIFICATION: "Annulation d'inscription"
}

export const renderNotificationMessage: Record<
  NotificationTypeEnum,
  (notification: Notification) => string
> = {
  ADMIN_REMIND_PCR: (notification) =>
    `${notification.message} : ${notification.staffApplication.firstName} ${notification.staffApplication.lastName}`,
  ADMIN_CHANGE_PCR: (notification) => notification.message,
  ADMIN_CHANGE_CANDIDATE_PRIORITY: (notification) => notification.message,
  PCR_CLASSIFY_CANDIDATE: (notification) =>
    `La candidature de "${notification.staffApplication.firstName} ${notification.staffApplication.lastName}" a été mise à jour. Le PCR l'a classée comme ${notification.message}`,
  RESERVATION_REMINDER: (notification) => notification.message,
  MISSING_DPAE_REMINDER: (notification) => notification.message,
  STAFF_ATTENDANCE_FINALIZED: (notification) => notification.message,
  AFFECTED_STAFF_APPLICATION_INCOMPLETE: (notification) => notification.message,
  DIFFUSION_NOTIFICATION: (notification) => notification.message,
  ENROLLMENT_CANCELLATION_NOTIFICATION: (notification) => notification.message
}
